<template lang="html">
  <div>
    <div class="row middle-xs">
      <div class="col-xs-2">
        <pl-input
          class="w-100"
          v-model="user_search"
          placeholder="Search by name"
          @keyup.enter="filters"
        />
      </div>
      <div class="col-xs-2">
        <pl-input
          class="w-100"
          v-model="email_search"
          placeholder="Search by email"
          @keyup.enter="filters"
        />
      </div>
      <div class="subjects col-xs-2">
        <multiselect
          v-model="selected_subjects"
          :options="subjects"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Subjects"
          label="name"
          track-by="id"
          :limit="1"
          :preselect-first="true"
          @input="filters"
          style="max-width: 100%;"
        >
          <template slot="selection" slot-scope="{ values, search, isOpen }">
            <span
              class="multiselect__single"
              v-if="selected_subjects.length &amp;&amp; !isOpen"
            >
              {{ selected_subjects.length }} options selected
            </span>
          </template>
        </multiselect>
      </div>
      <div :class="[hasAdminAdminPermission ? 'col-xs-2' : 'col-xs-3']">
        <pl-select
          :options="teachers"
          :selected="selected_userType"
          :disabled="show_trial_teachers"
          :arrow="true"
          placeholder="All users"
          style="padding: 0px;"
          class="dialog-role-select"
          @change="filterUsersByType($event)"
        >
        </pl-select>
      </div>
      <div :class="[hasAdminAdminPermission ? 'col-xs-2' : 'col-xs-3']">
        <multiselect
          v-model="selected_school_sites"
          :options="schoolSites"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="All Sites"
          label="name"
          track-by="id"
          :limit="1"
          :preselect-first="true"
          @input="filters"
          style="max-width: 100%;"
        >
          <template slot="selection" slot-scope="{ values, search, isOpen }">
            <span
              class="multiselect__single"
              v-if="selected_school_sites.length &amp;&amp; !isOpen"
            >
              {{ selected_school_sites.length }} school sites selected
            </span>
          </template>
        </multiselect>
      </div>
      <div class="col-xs-2 end-xs" v-if="hasAdminAdminPermission">
        <toggle-button
          @change="handleTrialTeachers"
          :value="show_trial_teachers"
          :labels="true"
          color="#72ccd7"
        />
        <span class="ml2"> Trial Teachers </span>
      </div>
    </div>

    <div>
      <span class="permissions-work-style">
        <a
          href="https://support.parlayideas.com/en/articles/5376837-admin-portal-permissions"
          target="_blank"
          >How do permissions work?
        </a></span
      >
    </div>
    <div v-if="show_trial_teachers" class="trial-div mv3">
      This is a list of teachers whose accounts are not upgraded, but whose
      email addresses also match the approved email suffixes for your school /
      district. Press upgrade to automatically upgrade these teacher accounts so
      they can have full access to Parlay. You may see names here that are part
      of your district, but not part of your school.
    </div>
  </div>
</template>

<script>
  import { EventBus } from 'utils/event-bus';
  import { mapGetters } from 'vuex';
  import Multiselect from 'vue-multiselect';
  export default {
    components: {
      Multiselect,
    },
    watch: {
      show_trial_teachers() {
        if (this.show_trial_teachers) {
          this.$emit('getTrialTeachers');
        } else {
          this.$emit('getUsers');
        }
      },
    },
    computed: {
      ...mapGetters(['hasAdminAdminPermission']),
    },
    data() {
      return {
        user_search: '',
        email_search: '',
        subjects: [],
        show_trial_teachers: false,
        selected_subjects: [],
        teachers: ['All', 'Teacher', 'Student'],
        selected_userType: 'Teacher',

        selected_school_sites: [],
      };
    },
    props: {
      schoolSites: {
        type: Array,
        default: [],
      },
    },
    methods: {
      refreshTable() {},
      filters() {
        const filters = {
          name: this.user_search,
          email: this.email_search,
          subjects_ids: this.selected_subjects.map((subject) => subject.id),
          roles: this.selected_userType.toLowerCase(),
          school_sites_ids: this.selected_school_sites.map((site) => site.id),
        };
        this.$emit('parlay-users-filter-changed');
        this.$emit('filters', {
          filters: filters,
          trial_teachers: this.show_trial_teachers,
        });
      },
      filterUsersByType(event) {
        this.selected_userType = event.toLowerCase();
        const filters = {
          name: this.user_search,
          email: this.email_search,
          subjects_ids: this.selected_subjects.map((subject) => subject.id),
          roles: this.selected_userType,
        };
        this.$emit('parlay-users-filter-changed');
        this.$emit('filters', {
          filters: filters,
          trial_teachers: this.show_trial_teachers,
        });
      },
      handleTrialTeachers() {
        EventBus.$emit('show_trial_teachers');
        this.selected_userType = 'Teacher';
        this.show_trial_teachers = !this.show_trial_teachers;
      },
    },
    created() {},
    mounted() {
      this.$store
        .dispatch('getSchoolSubjects')
        .then((results) => (this.subjects = results));
    },
  };
</script>

<style lang="stylus" scoped>
  @import '~app/global-stylus.styl';

  .permissions-work-style{
    color: #78BEC8
  }

  .trial-teachers{
    display: flex !important
    align-items: center
    justify-content: center
  }

  .trial-div
    color:#5FA95C
  .dialog-role-select{
    height: 40px;
    border: 2px solid #e1e8ee;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  a
    color: #78BEC8
    text-decoration: none
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  .multiselect {
    .multiselect__content-wrapper {
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// adminPortalUsersFiltersBar.vue?229a0eb1